import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SiteSetupService } from 'app/client-core/services/site-setup';
import { SiteMenuModel } from 'app/client-core/dtos/site-menu.model';

@Component({

  selector: 'sa-big-breadcrumbs',
  template: `
   <div><h1 class="page-title txt-color-blueDark">
   <i [class]="menuIcon"></i>{{ menuTitle }}
   <span *ngFor="let item of items.slice(1)">> {{ additionalItems }}</span>
</h1><ng-content></ng-content></div>
  `,
})
export class BigBreadcrumbsComponent implements OnInit, OnChanges {
  menuTitle: string;
  menuIcon: string;
  @Input() public icon: string;
  @Input() public items: Array<string>;
  @Input() public additionalItems: Array<string>;

  constructor(
    private siteSetupService: SiteSetupService,
    private router: Router,
  ) {

  }

  ngOnChanges() {
    const menus = this.siteSetupService._getCachedSiteMenu();
    this.setMenuTitle(menus);
  }

  ngOnInit() {
    const menus = this.siteSetupService._getCachedSiteMenu();
    this.setMenuTitle(menus);

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setMenuTitle(menus);
      }
    });
  }

  setMenuTitle(menuItems: Array<SiteMenuModel>) {
    menuItems.forEach(item => {
      if (item.navLink == this.router.url.trim()) {
        this.menuTitle = item.displayName;
        this.menuIcon = item.icon;
        console.log(item.navLink);
        console.log('route ', this.router.url);
      }
      if (item.children && item.children.length > 0) {
        this.setMenuTitle(item.children);
      }
    });
  }

  loopMenu() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/big-breadcrumbs.component.ts